/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormControlLabel, Checkbox, Snackbar, Divider } from "@material-ui/core";
import { ReflexContainer, ReflexSplitter, ReflexElement } from "react-reflex";
import { makeStyles } from "@material-ui/styles";
import { Alert } from "@material-ui/lab";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import "react-reflex/styles.css";

import uiConf from "../../config/uiConf";

import apiClient from "../../lib/common/apiClient";
import checkLogin from "../../lib/auth/checkLogin";

import Dialog from "../dialog/functional/Dialog";
import DialogHeader from "../dialog/functional/DialogHeader";
import DialogContent from "../dialog/functional/DialogContent";
import DialogTitle from "../dialog/functional/DialogTitle";
import DialogActionsOkCancel from "../dialog/functional/DialogActionsOkCancel";

import MomSysSoProductionSo from "../screens/MomSysSoProductionSo";
import SelectProductionItem from "../screens/SelectProductionItem";

const useStyles = makeStyles((theme) => ({
    keepOpenSwitch: {
        marginLeft: "8px"
    },
    label: {
        fontSize: "smaller",
        color: theme.palette.primary.text
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
  
}));
function CreateProductionPlanDialog ( props ) {

    const classes = useStyles();
    const { t } = useTranslation ();

    const [, setSoApi] = useState ();
    const [, setPlans] = useState ([]);

    const [instance, setInstance] = useState ();
    const [so, setSo] = useState ();
    const [buttonDisabled, setButtonDisabled] = useState ([true, false]);
    const [loading, setLoading] = useState (false);
    const [openProgress, setOpenProgress] = useState(false);
    const [keepOpen, setKeepOpen] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        severity: "success",
        msg: "",
    });

    const {

        id,
        
        moveable,
        resizable,
        fullWidth,
        maxWidth,

        onClose,
        onInitialized,
        onSuccess,

        ...others

    } = props;

    const notifyWarning = (msg) => {

        console.warn (msg);

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const notifyFailure = (msg) => {

        console.error ( msg );

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onDialogInitialized = ( instance ) => {

        setInstance(instance);

        if ( onInitialized ) {

            onInitialized ( instance );

        }

    };

    const onApiSuccess = (result) => {

        setOpenProgress ( false );

        if ( onSuccess ) {

            onSuccess ( t ( "success.createProductionPlanSuccess"), result?.data?.planId );

        }

        setInstance ( ( instance ) => {

            if ( instance ) {


                setKeepOpen ( ( keepOpen ) => {

                    if ( ! keepOpen ) {
        
                        instance.hide();
        
                    } else {

                        setSoApi ( ( soApi ) => {

                            if ( soApi ) {

                                soApi.refresh();

                            }

                            return soApi;

                        } );
                    
                    }
        
                    return keepOpen;
        
                } );
        
            }

            return instance;
        })

    };

    const onApiFailure = ( apiData, reason ) => {

        setOpenProgress ( false );
        console.error ( apiData );
        notifyFailure ( t ( "error.createProductionPlanFail" ) + ` : ${ reason.response ? reason.response.data : JSON.stringify ( reason ) }` );

    };

    const convertProcessPlans = ( plans ) => {

        let result = [];

        for ( let plan of plans ) {;
            
            console.log ( "convertProcessPlans", plan );

            if ( plan.produce ) {

                let processPlan = {
    
                    taskType: "processPlan",
                    taskName: plan.taskName,
                    processCode: plan.processCode,
                    processName: plan.processName,
                    materialCode: plan.materialCode,
                    materialCodeVer: plan.materialCodeVer,
                    outSourcing: plan.outSourcing ?? 0,
                    children: convertMaterialPlans ( plan.children ),
    
                };
    
                result.push ( processPlan );
    
            }

        }

        return result;

    };
    
    const convertMaterialPlans = ( plans ) => {

        let result = [];

        for ( let plan of plans ) {
            
            console.log ( "convertMaterialPlans", plan );

            if ( plan._data?.taskType === 'materialPlan' && plan._data?.produce ) {

                // console.log ( plan._data );

                let materialPlan = {

                    taskType: "materialPlan",
                    taskName: plan._data.taskName,
                    orderBuyerDetailId: plan._data.orderBuyerDetailId,
                    materialCode: plan._data.materialCode,
                    materialCodeVer: plan._data.materialCodeVer,
                    materialName: plan._data.materialName,
                    qty: plan._data.qty,
                    children: convertProcessPlans ( plan._data.children ),
    
                };
    
                result.push ( materialPlan );

            }

        }

        return result;

    };

    /*
    const convertOrderBuyerDetailPlans = ( plans ) => {
        
        let result = [];

        for ( let plan of plans ) {

            if ( plan._data.taskType === 'orderBuyerDetailPlan' && plan._data.produce ) {

                let orderBuyerDetailPlan = {

                    taskType: "orderBuyerDetailPlan",
                    orderBuyerDetailId: plan._data.orderBuyerDetailId,
                    materialCode: plan._data.materialCode,
                    materialCodeVer: plan._data.materialCodeVer,
                    materialName: plan._data.materialName,
                    children: convertProcessPlans ( plan._data.children ),
    
                };
    
                result.push ( orderBuyerDetailPlan );
    
            }

        }

        return result;
    };
    */

    const CheckLogin = () => {

        ( async () => {
        
            await checkLogin ();
                    
            setOpenProgress ( ( opened ) => {
    
                if ( opened ) {
    
                    setTimeout ( () => {
    
                        CheckLogin ();
    
                    }, 15000 );
    
                }
    
                return opened;
    
            } );
    
        } ) ();

    }
    const onOk = () => {

        setSo ( ( so ) => {

            setPlans ( ( plans ) => {

                if ( plans.length <= 0 ) {
                    return plans;
                }

                let apiData = {
                    taskType: "orderBuyerMstPlan",
                    // taskName: `${t("columnName.workOrderNumber")} ${so.workOrderNumber ? so.workOrderNumber : ""}`,
                    taskName: `${so.workOrderNumber ? so.workOrderNumber : ""} ${so.modelName} ${so.modelPartName}`,
                    orderBuyerId: so.orderBuyerId,
                    workOrderNumber: so.workOrderNumber,
                    children: convertMaterialPlans ( plans )
                };

                // console.log ( apiData );

                let form = new FormData ();
                let json = apiData;
                let deleted = {};

                form.append ( "deleted", JSON.stringify ( deleted ) );
                form.append ( "json", JSON.stringify ( json ) );
                
                setOpenProgress ( true );

                setTimeout ( () => {

                    CheckLogin ();

                }, 15000 );

                apiClient
                .post("/api/TkPlan", form, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((result) => onApiSuccess(result))
                .catch((reason) => onApiFailure(apiData, reason));

                return plans;
    
            } );
    
            return so;

        } );        
            
    }

    const onCancel = () => {

        instance.hide ();

    };


    const onCloseNotification = () => {

        setNotification ( ( notification ) => {

            return ( {...notification, open: false} );

        } );

    };

    const onCloseDialog = () => {
        
        if ( onClose ) {

            onClose ();

        }

    };

    const onSelectSo = ( so ) => {

        setLoading ( true );
        setSo ( so );

    }

    const onChangeProductionPlan = ( plans ) => {

        setPlans ( plans );

        if ( plans.length > 0 ) {

            let planCount = 0;

            for ( let plan of plans ) {

                if ( plan._data.produce ) {

                    planCount++;

                }

            }

            setButtonDisabled ( [!planCount, false] );

        } else {

            setButtonDisabled ( [true, false] );

        }

    }

    const onNotifyError = ( msg ) => {

        notifyFailure ( msg );
        
    }

    const checkKeepOpen = () => {

        return (
            <>

                <FormControlLabel
                    control={

                        <Checkbox
                            className={classes.keepOpenSwitch}
                            checked={keepOpen}
                            color="primary"
                            onChange={() => setKeepOpen((keepOpen) => (!keepOpen))}
                            name="checkKeepOpen"
                            size="small"
                        />
                    }
                    label={<span className={classes.label}>{t("term.keepDialogOpen")}</span>}
                />
                <div style={{ flexGrow: 1 }}></div>

            </>

        )

    }

    const onSoApiInitialized = ( soApi ) => {

        setSoApi ( soApi );

    }
    
    const onLoadData = () => {

        setLoading ( false );

    }

    return (

        <>

            <Dialog
                id={id}
                moveable={moveable ? moveable : uiConf.dialogMoveable}
                resizable={resizable ? resizable : uiConf.dialogResizable}
                fullWidth={fullWidth ? fullWidth : uiConf.dialogFullWidth}
                maxWidth="lg"
                onClose={onCloseDialog}
                onInitialized={onDialogInitialized}
                {...others}
            >

                <DialogHeader>
                    <DialogTitle>
                        { t ( "dialog.title.ProductionPlan.createProductionPlan" ) }
                    </DialogTitle>
                </DialogHeader>

                <Divider />

                <DialogContent style={{padding: "0px", height: "710px"}}>

                    <ReflexContainer orientation="vertical">

                        <ReflexElement flex={0.5} >

                            <MomSysSoProductionSo
                                embededInOtherScreenType
                                onSelect={onSelectSo}
                                onApiInitialized={onSoApiInitialized}
                            />

                        </ReflexElement>

                        <ReflexSplitter
                            style={{border: "none",width: "1px",color:"lightgray"}}
                        />

                        <ReflexElement flex={0.5} >

                            <SelectProductionItem so={so} embededInOtherScreenType onChange={onChangeProductionPlan} onNotifyError={onNotifyError} notifyWarning={notifyWarning} onLoadData={onLoadData} />

                        </ReflexElement>

                    </ReflexContainer>

                    <Snackbar
                        open={notification.open && notification.severity !== "success"}
                        autoHideDuration={uiConf.dialogNotifyAutoHideDuration}
                        onClose={onCloseNotification}
                    >
                        <Alert
                            onClose={onCloseNotification}
                            variant="filled"
                            severity={notification.severity}
                        >

                            {notification.msg}

                        </Alert>

                    </Snackbar>

                </DialogContent>

                <Divider />

                <DialogActionsOkCancel
                    firstActionComponent={checkKeepOpen}
                    buttonDisabled={ openProgress ? [ true, true ] : buttonDisabled }
                    onOk={() => onOk()}
                    onCancel={onCancel}
                />

                <Backdrop className={classes.backdrop} open={openProgress || loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>            

            </Dialog>

        
        </>

    );

}

export default CreateProductionPlanDialog;
